const DEFAULT_PAGINATION_SIZE = 50;
export const TINY_API_TOKEN = process.env.REACT_APP_TINY_API_TOKEN;

export const MAX_RELATED_ARTICLES_LISTING = 12;
export default DEFAULT_PAGINATION_SIZE;
